/**
 * Renders a list of tag aliases
 */

import React from 'react';

// Translation
import translate from '../translate/Translate';

// Icons
import * as icons from '../ui/Icons';

// Components
import EditCutPoint from '../forms/EditCutPoint';
import Button from '../common/Button';

export const CutPoints = class CutPoints extends React.Component {
  constructor() {
    super();

    // Set the initial state
    this.state = {
      cutPoint: null,
      editing: false
    }
  }

  handleDelete(i) {
    const { onDelete, store, translation } = this.props;
    const { AppStore } = store;

    const callback = () => {
      AppStore.toast = translation.deleted;
    }

    AppStore.showDialog(
      translation.delete_confirm,
      'confirm',
      () => onDelete(i, callback)
    );
  }

  renderNewBtn() {
    const { translation } = this.props;

    return (
      <Button
        className="btn btn--outline btn--center"
        type="button"
        onClick={() => this.setState({ editing: true })}
      >
        {translation.new_cut_point}
      </Button>
    )
  }

  render() {
    const {
      assessment,
      cutPoints,
      onSubmit,
      translation
    } = this.props;
    const {
      cutPoint,
      cutPointIndex,
      editing
    } = this.state;

    if(editing) {
      return (
        <EditCutPoint
          {...this.props}
          cutPoint={cutPoint}
          cutPointIndex={cutPointIndex}
          assessment={assessment}
          onClose={() => this.setState({
            cutPoint: null,
            cutPointIndex: -1,
            editing: false
          })}
          onSubmit={onSubmit}
        />
      )
    } else {
      return (
        <div>
          {(!cutPoints || cutPoints.length === 0) &&
            <span className="no-results">
              {translation.no_results}
            </span>
          }

          {cutPoints && cutPoints.length > 0 &&
            <ul className="grid grid--wrap" data-columns="3">
              {cutPoints.map(
                (cutPoint, i) =>
                <li
                  className="grid__item"
                  key={i}
                >
                  <article
                    className="panel panel--card"
                  >
                    <h2 className="panel__title panel__title--alt">
                      <Button
                        className="btn--title"
                        type="button"
                        onClick={() => this.setState({
                          cutPoint: cutPoint,
                          cutPointIndex: i,
                          editing: true 
                        })}
                      >
                        {cutPoint.variable}
                      </Button>
                    </h2>

                    <Button
                      className="btn btn--ghost btn--negative panel__remove"
                      type="button"
                      onClick={() => this.handleDelete(i)}
                    >
                      <icons.times />
                      <span className="meta">
                        {translation.delete_cut_point}
                      </span>
                    </Button>

                      {cutPoint.description &&
                        <p>{cutPoint.description}</p>
                      }
                  </article>
                </li>
              )}
            </ul>
          }

          {this.renderNewBtn()}
        </div>
      )
    }
  }
}

export default translate('CutPoints')(CutPoints);